import { memo } from 'react'

import { getNavigationIcon } from '@/constants/navigationAssets'

import { RatingContainer, RatingText, ReviewsText } from '../ParkingTile.styled'

interface RatingProps {
  reviews?: number
  rating?: string
}

const Rating: React.FC<RatingProps> = ({ reviews, rating }) => {
  if (reviews == 0) {
    return <></>
  }

  return (
    <RatingContainer>
      {reviews && <ReviewsText>{reviews} reviews</ReviewsText>}
      {rating && (
        <RatingText>
          <img
            src={getNavigationIcon('starFilled')}
            alt="star rating"
            loading="lazy"
          />
          {rating}
        </RatingText>
      )}
    </RatingContainer>
  )
}

export default memo(Rating)
